import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { ReferenceModel } from '../model/index';

@Injectable()
export class ReferenceService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private referenceUrl = 'api/reference';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getReferenceList(query: any): Promise<ReferenceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.referenceUrl}/referenceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getMergeReferenceList(query: any): Promise<ReferenceModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.referenceUrl}/getMergeReferenceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    onUpdateReference(referenceData: any): Promise<ReferenceModel> {

        const url = `${this.referenceUrl}/onUpdateReference`;

        return this.http
            .post(url, $.param(referenceData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ReferenceModel)
            .catch(this.handleError);
    }

    getReference(ref_id: number): Promise<ReferenceModel> {
        const url = `${this.referenceUrl}/referenceList?ref_id=${ref_id}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as ReferenceModel)
            .catch(this.handleError);
    }

    deleteReference(ref_id: any): Promise<ReferenceModel> {
        const url = `${this.referenceUrl}/deleteReference`;
        return this.http
            .post(url, $.param({ ref_id: ref_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ReferenceModel)
            .catch(this.handleError);
    }

    addEditUpdateReference(referenceData: any): Promise<ReferenceModel> {

        const url = `${this.referenceUrl}/addEditUpdateReference`;

        return this.http
            .post(url, $.param(referenceData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ReferenceModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/reference.service.ts